import { render, staticRenderFns } from "./StudentGradeTable.vue?vue&type=template&id=13a67441&scoped=true"
import script from "./StudentGradeTable.vue?vue&type=script&lang=js"
export * from "./StudentGradeTable.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=13a67441&prod&scoped=true&lang=css&external"
import style1 from "./StudentGradeTable.vue?vue&type=style&index=1&id=13a67441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a67441",
  null
  
)

export default component.exports